<template>
  <div class="h-100">
    <div id="wrapper" class="col-md-10 mr-auto ml-auto mt-5" style="overflow:scroll;">

      <div v-if="!completed">
        <label for="">Describe the pain you are experiencing today</label>
        <div class="row">
          <div class="col-12">
            <div class="d-flex" style="width: 100%;justify-content: space-between;">
              <div>😀</div>
              <div>🙂</div>
              <div>😕</div>
              <div>🙁</div>
              <div>😟</div>
              <div>😞</div>
            </div>
            <input type="range" min="0" max="10" step="1" v-model="painScore" style="width: 100%" class="mt-2">
            <div class="d-flex" style="width: 100%;justify-content: space-between;">
              <div>
                <small>No pain
                </small>
              </div>
              <div>
                <small>Moderate pain
                </small>
              </div>
              <div>
                <small>Worst pain
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="completed" style="display: grid;place-items: center;">
        <agree-svg></agree-svg>

        <h6 class="mt-3">Checkin completed</h6>
      </div>
    </div>

    <div class="col-12 mt-5" style="text-align:center" v-if="!completed">
      <n-button type="primary" round size="md" @click.native="checkin">
        Submit
      </n-button>
    </div>
  </div>
</template>

<script>
import AgreeSvg from '../components/svg_images/AgreeSvg.vue'
export default {
  name: "checkin",

  components: {
    AgreeSvg
  },

  data() {
    return {
      painScore: 0,
      patient: JSON.parse(localStorage.user),
      completed: false
    }
  },

  mounted() {

  },

  methods: {
    async checkin() {
      try {
        await this.$store.dispatch('saveQuestionnaireAnswers', {
          name: 'Checkin',
          patientId: this.patient.patientId,
          answer: '{"fields": [{"displayName"": "What is your pain score?", "value": ' + this.painScore + ' }]}',
          completed: true
        })

        this.completed = true
        swal.fire({
          type: 'success',
          title: 'Checkin complete',
        })
      }
      catch (e) {
        console.log(e)
        swal.fire({
          type: 'error',
          title: 'Checkin complete',
        })
      }

    }
  }

};

</script>

<style scoped>
.autocomplete-result {
  margin-top: 1em;
  margin-bottom: 1em;
}

/deep/.triaging-tiles .card-body {
  padding: 15px;
}

/deep/ .consents-dropdown .dropdown {
  width: 100%;
  border: #0000008c solid 0.5px;
  border-radius: 2em;
}

/deep/.consents-dropdown .nav-link {
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
